import styled from "styled-components";
import MaskInput from "react-input-mask";

export const MaskInputStyled = styled(MaskInput)`
  border-radius: 8px;
  border: 1px solid #b5b5b5;
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  outline: none;
  transition: all 300ms ease-out;

  &::placeholder {
    color: #333;
  }
  &:hover {
    background-color: #f5f5f5;
  }
  &:focus {
    box-shadow: none;
    background-color: #f5f5f5;
  }
  &.error {
    border-color: red;
  }
`;
